// AverageResponseTimes.js
import React from 'react';
import { Card, CardHeader, CardBody, Heading, Box } from 'grommet';
//import { ShareOption} from 'grommet-icons';
import Iframe from 'react-iframe';


const AverageResponseTimesComp = () => {
//  const size = useContext(ResponsiveContext);
//  const year = new Date().getFullYear();


  return (
    <Card height="350px" elevation="medium">
      <CardHeader pad={{ horizontal: 'medium', top: 'small', bottom: 'none' }}>
        <Box>
          <Heading margin="none" level={2} pad="none">
            Average response times
          </Heading>
        </Box>
      </CardHeader>
      <CardBody pad={{ horizontal: 'medium', top: 'none', bottom: 'small' }} gap="small" align="start" fill>
        <Iframe url="https://chart-embed.service.newrelic.com/herald/dd9de1da-4fbd-4089-95ee-859a4172549f?timepicker=true"
          width="100%" 
          height="100%"
          frameBorder="0"
          overflow="visible"
          allowFullScreen
          scrolling="no"
          id=""
          className=""/>
      </CardBody>
     
    </Card>
  );
};

export { AverageResponseTimesComp as SampleGraphEmbed };
